class FadeCarousel extends HTMLElement {
    constructor() {
      super();
      this.wrapper = this.querySelector('.fade-carousel__slides-wrapper')
      this.currentIndex = 0;
      this.slides = [];
      this.buttons = [];

    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.split-image-text__block'));

      if (!this.slides.length) return;

      this.buttons = Array.from(this.querySelectorAll('.fade-carousel__button'));

      this.showSlide(this.currentIndex);

      this.setHeight();
      window.addEventListener('resize', () => this.setHeight());

      this.buttons.forEach((button, i) => {
        button.addEventListener('click', () => this.showSlide(i));
      });
    }

    showSlide(index) {
      this.currentIndex = index; // update currentIndex first

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('active', i === index);
      });

      this.buttons.forEach((btn, i) => {
        btn.classList.toggle('active', i === index);
      });

      this.setHeight(); // call setHeight after activating the new slide
    }

    setHeight() {
      const activeSlide = this.slides[this.currentIndex];
      if (activeSlide) {
        requestAnimationFrame(() => {
          this.wrapper.style.height = `${activeSlide.offsetHeight}px`;
        });
      }
    }
}

customElements.define('fade-carousel', FadeCarousel);
